var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 6,
  width: 23,
  height: 31,
  rx: 2.5,
  fill: "#a7b2ba"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 16.5,
  y: 6.6,
  width: 12,
  height: 1.4,
  rx: 0.7,
  fill: "#8a6238"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m14.5 13.5 2-5.7h12l2 5.7z",
  fill: "#b07845"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 13.5,
  width: 16,
  height: 10.5,
  rx: 1.5,
  fill: "#3f4a54"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 20.9,
  y: 11.7,
  width: 3.8,
  height: 3.8,
  rx: 0.9,
  fill: "#bfe3f2"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 17.4,
  y: 15.6,
  width: 4,
  height: 4,
  rx: 0.9,
  fill: "#bfe3f2"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 21.9,
  y: 15.6,
  width: 4,
  height: 4,
  rx: 0.9,
  fill: "#bfe3f2"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 15.2,
  y: 19.8,
  width: 4,
  height: 4,
  rx: 0.9,
  fill: "#bfe3f2"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 19.7,
  y: 19.8,
  width: 4,
  height: 4,
  rx: 0.9,
  fill: "#bfe3f2"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 24.2,
  y: 19.8,
  width: 4,
  height: 4,
  rx: 0.9,
  fill: "#bfe3f2"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 13.5,
  y: 26.5,
  width: 18,
  height: 8,
  rx: 1.2,
  fill: "#98a5ad"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 28,
  width: 8,
  height: 1.4,
  rx: 0.7,
  fill: "#5c6870"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.7,
  cy: 30.7,
  r: 1,
  fill: "#58c47a"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 13.5,
  y: 37,
  width: 3,
  height: 2.2,
  rx: 0.6,
  fill: "#7d8a93"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 28.5,
  y: 37,
  width: 3,
  height: 2.2,
  rx: 0.6,
  fill: "#7d8a93"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 35.6,
  y: 34.6,
  width: 4.4,
  height: 4.4,
  rx: 1,
  fill: "#bfe3f2"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 38.6,
  y: 30,
  width: 3.6,
  height: 3.6,
  rx: 0.9,
  fill: "#bfe3f2"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m39.6 22.4 0.7 1.4 1.4 0.7-1.4 0.7-0.7 1.4-0.7-1.4-1.4-0.7 1.4-0.7z",
  fill: "#9fd8ef"
});

function SvgIceMachine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceMachine);
export default __webpack_public_path__ + "static/media/ice-machine.7e6e5a37b22243e46de834d806d2ee9a.svg";
export { ForwardRef as ReactComponent };